// extracted by mini-css-extract-plugin
module.exports = {"main":"Alert_main__2mhyW","error":"Alert_error__HLnt2","icon":"Alert_icon__1FuJc","warning":"Alert_warning__p40dn","iconWrapper":"Alert_iconWrapper__3oQ0U"};